/** Shared badge/colour helpers for AML match cards and detail modal. */

export function getAmlRiskBadgeColor(category) {
  const c = String(category || '')
  if (/^PEP$/i.test(c)) return 'bg-red-100 text-red-800 border-red-200'
  if (/adverse/i.test(c)) return 'bg-amber-100 text-amber-900 border-amber-200'
  if (/associate/i.test(c)) return 'bg-blue-100 text-blue-800 border-blue-200'
  if (/sanction/i.test(c)) return 'bg-purple-100 text-purple-800 border-purple-200'
  switch (category) {
    case 'PEP':
      return 'bg-red-100 text-red-800 border-red-200'
    case 'RCA':
      return 'bg-orange-100 text-orange-800 border-orange-200'
    case 'SIP':
      return 'bg-yellow-100 text-yellow-800 border-yellow-200'
    case 'SIE':
      return 'bg-purple-100 text-purple-800 border-purple-200'
    default:
      return 'bg-gray-100 text-gray-800 border-gray-200'
  }
}

export function getAmlConfidenceColor(confidence) {
  if (confidence >= 90) return 'text-red-600'
  if (confidence >= 75) return 'text-orange-600'
  if (confidence >= 60) return 'text-yellow-600'
  return 'text-gray-600'
}

export function getAmlRiskLevelColor(riskLevel) {
  const r = String(riskLevel || '')
  if (r === 'Critical') return 'bg-red-500 text-white border-red-600'
  if (r === 'High' || /high risk/i.test(r)) return 'bg-orange-500 text-white border-orange-600'
  if (r === 'Medium') return 'bg-yellow-500 text-white border-yellow-600'
  if (r === 'Low' || r === 'Clear') return 'bg-green-500 text-white border-green-600'
  if (r === 'Review') return 'bg-amber-500 text-white border-amber-600'
  return 'bg-gray-500 text-white border-gray-600'
}

export function getAmlThreatLevelColor(threatLevel) {
  switch (threatLevel) {
    case 'High Threat':
      return 'bg-red-100 text-red-800 border-red-300'
    case 'Political Risk':
      return 'bg-orange-100 text-orange-800 border-orange-300'
    case 'Sanctioned Individual':
      return 'bg-purple-100 text-purple-800 border-purple-300'
    case 'Standard':
      return 'bg-gray-100 text-gray-800 border-gray-300'
    default:
      return 'bg-gray-100 text-gray-800 border-gray-300'
  }
}
